<template>
  <div class="rb">
    <div class="rb-top">
      <div class="main" v-for="(item, index) in cropsData" :key="index">
        <div class="m-item ">
          <p class="title">{{ item.name }}</p>

          <span class="num">{{ item.num1 }}</span>

          <span class="unit">{{ item.unit }}</span>
        </div>
        <div class="line"></div>
        <div class="line2"></div>
      </div>
    </div>
    <div class="rb-bottom">
      <div class="main2">
        <div class="ani-img showOp"></div>
        <div class="main2-bg ">
          <img src="../../assets/template3/temporary1.png" alt="" class="img ">
        </div>
        <div class="ani-img showOp"></div>
        <div class="main2-bg">
          <img src="../../assets/template3/temporary2.png" alt="" class="img " style="left: 200px;">
        </div>
        <div class="ani-img showOp" style="top: -4px"></div>
        <div class="main2-bg">
          <img src="../../assets/template3/temporary3.png" alt="" class="img " style="top: 154px;">
        </div>
        <div class="ani-img showOp" style="top: -4px"></div>
        <div class="main2-bg">
          <img src="../../assets/template3/temporary4.png" alt="" class="img " style="top: 154px;left: 200px;">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'template.rightB.temp3',
  data() {
    return {
      topMap: [],
      select: {},
      cropsData: [
        { name: "总面积", val: "ha", num1: '158', unit: "公顷" },
        { name: "重点监控面积", val: "kg", num1: '234', unit: "公斤" },
        { name: "事故预警数", val: "kind", num1: '24', unit: "条" }
      ],
    };
  },
  watch: {},
  methods: {


  },
  mounted() {

  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.rb {
  width: 435px;
  height: 390px;
  padding: 10px 0;
  position: relative;

}

.rb-top {
  width: 435px;
  height: 82px;
  margin: 14px 0 0 0;
  background: url('../../assets/template3/title-text-bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  z-index: 1;
}

.main {
  width: 435px;
  display: flex;
  text-align: center;
}

.m-item {
  // flex: 1;
  padding: 12px 0 0 24px;

  .title {
    width: 85px;
    height: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 10px;

  }

  .num {
    width: 36px;
    height: 17px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin: 0 6px 0 0;
  }

  .unit {
    width: 24px;
    height: 11px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #CBCBCB;
  }
}

.line {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  left: 146px;
  top: 34px;
}

.line2 {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  right: 156px;
  top: 34px;
}

.rb-bottom {
  width: 414px;
  height: 294px;
  position: relative;
  // margin-top: 82px;
  // background: pink;
  z-index: 1;
  display: flex;
  margin-left: 20px;
}

.main2 {
  margin-top: 10px;
  width: 414px;
  height: 294px;
  display: flex;
  flex-wrap: wrap;
}

.ani-img {
  width: 200px;
  height: 140px;
  background: url(../../assets/template3/img-bg.png) no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;

}

.img {
  position: absolute;
  left: 0px;
  margin: 10px 0 0 8px;
  width: 184px;
  height: 120px;
  z-index: 11;
}
</style>